export default ":host {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n}";